import React from 'react'

import { SectionContainer } from '../../layouts'
import {
  backgroundClassName,
  contentCotainer,
  ctaSectionContainer,
  fontColor,
  headingStyling,
} from './MothersCta.module.css'

const MothersCta = () => {
  const ctaheading =
    'This Mother’s Day, give her more than a gift — give her a moment of beauty made just for her.'
  const content = `<h4>Choose from three exclusive options:</h4>
  <ul>
  <li>• Pay €40, and she’ll receive €50 in value</li>
  <li>• Pay €50, and she’ll receive €75 in value</li>
  <li>• Pay €150, and she’ll receive €200 in value</li>
  </ul>
<p>✨ Beautifully presented and ready to gift, each card offers her the freedom to choose what makes her feel most radiant — from revitalizing facials to personalized skincare consultations and beyond.
Available all May at Essential Aesthetics.</p>`
  return (
    <SectionContainer
      backgroundClassName={backgroundClassName}
      extraClassName={ctaSectionContainer}
      extraContentClassName={contentCotainer}
      extraHeadingClassName={fontColor}
      extraHeadingContainerClassName={headingStyling}
      extraKickerClassName={fontColor}
      heading={ctaheading}
      renderedContent={content}
      withCta
      withHeader
    />
  )
}

export default MothersCta
